@if (useTimegrid() && startOptions().length) {
  <div class="mt-8">
    <h2>{{ 'common.time' | actrans }}</h2>
    <div nz-row [nzGutter]="16">
      <div nz-col [nzSpan]="12">
        <nz-form-item>
          <nz-form-label>{{ 'common.startTime' | actrans }}</nz-form-label>
          <nz-form-control>
            <nz-select [ngModel]="selectedStart()" (ngModelChange)="onStartChange($event)" nzShowSearch>
              @for (opt of startOptions(); track opt.value) {
                <nz-option [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzSpan]="12">
        <nz-form-item>
          <nz-form-label>{{ 'common.endTime' | actrans }}</nz-form-label>
          <nz-form-control>
            <nz-select [ngModel]="selectedEnd()" (ngModelChange)="onEndChange($event)" nzShowSearch>
              @for (opt of endOptions(); track opt.value) {
                <nz-option [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </div>
}
